import { useNavigationStore } from 'src/domain/stores/useNavigationStore';
import Constants from 'src/core/utils/Constants';

/**
 * Routes an event-deeplink push to the app: the automatic reminder (#349) and, since #380, every directly
 * sent push that does not point at a page.
 */
export function openEventFromPush(data: Record<string, unknown> | undefined): boolean {
	// A page push (data.url) keeps its own page-oriented flow.
	if (typeof data?.url === 'string' && data.url !== '') return false;

	const uri = typeof data?.uri === 'string' ? data.uri : null;
	if (!uri) return false;

	// Matches 'event/ABC123', 'topev://event/ABC123' and 'https://.../event/ABC123', but not a substring like
	// 'myevent/x' (anchored to start or a path separator).
	const match = uri.match(/(?:^|\/)event\/([^/?#]+)/i);
	const code = match?.[1] ? decodeURIComponent(match[1]) : null;
	if (!code) return false;

	useNavigationStore
		.getState()
		.resetToRoutes([{ name: Constants.screenIndex }, { name: Constants.screenEventDeeplink, params: { code } }]);

	return true;
}
